import api from "../_boot/baseApi";

export const getNotifications = ({commit, state}) => {
    if (state.user != null) {
        api.get(`/api/m/notifications/${state.user.id}`).then(({data}) => {
            commit("setNotifications", data);
        });
    }
};